import { writable } from 'svelte/store';
import { supabase } from '$lib/supabase';

interface LiveVideo {
    id: string;
    title: string;
    channel_title: string;
    thumbnail_url: string;
    channel_id: string;
    currentViewers: number;
    isRemoving?: boolean;
}

function createLiveRankingStore() {
    const { subscribe, set, update } = writable<LiveVideo[]>([]);

    return {
        subscribe,
        async fetchRankings() {
            const { data: liveVideos } = await supabase
                .from('video')
                .select('id, title, channel_title, thumbnail_url, channel_id, live_stats')
                .eq('live_broadcast_content', 'live');

            if (liveVideos) {
                const formattedLiveVideos = liveVideos.map(video => {
                    const liveStats = video.live_stats;
                    if (!liveStats) return { ...video, currentViewers: 0 };
                    const latestTimestamp = Object.keys(liveStats).sort().pop();
                    const concurrentViewers = liveStats[latestTimestamp];
                    return { ...video, currentViewers: concurrentViewers };
                });

                const newRankings = formattedLiveVideos
                    .map(video => ({
                        ...video,
                        currentViewers: video.currentViewers || 0
                    }))
                    .filter(video => video.currentViewers > 0)
                    .sort((a, b) => b.currentViewers - a.currentViewers);

                // 現在のランキングを取得
                let currentRankings: LiveVideo[] = [];
                subscribe(value => {
                    currentRankings = value;
                })();

                // 新しいランキングと現在のランキングを比較
                const addedVideos = newRankings.filter(newVideo => 
                    !currentRankings.some(currentVideo => currentVideo.id === newVideo.id)
                );
                const removedVideos = currentRankings.filter(currentVideo => 
                    !newRankings.some(newVideo => newVideo.id === currentVideo.id)
                );
                const reorderedVideos = newRankings.filter(newVideo => 
                    currentRankings.some(currentVideo => currentVideo.id === newVideo.id)
                );

                // 削除されたビデオにはremoveクラスを追加
                removedVideos.forEach(video => {
                    video.isRemoving = true;
                });

                // 新しいランキングを設定（削除されたビデオを含む）
                set([...reorderedVideos, ...addedVideos, ...removedVideos]);

                // 一定時間後に削除されたビデオを取り除く
                setTimeout(() => {
                    update(rankings => rankings.filter(video => !video.isRemoving));
                }, 500);
            }
        },

        reset() {
            set([]);
        }
    };
}

export const liveRankingStore = createLiveRankingStore(); 